import "./ErrorPopup.scss";
import Button from "components/Button/Button";
import {  useAppDispatch } from "store";

interface ErrorPopupProps {
  header?: string;
  errorText?: string;
  onClose?: () => void;
}

const ErrorPopup = ({ header, errorText, onClose }: ErrorPopupProps) => {
  const dispatch = useAppDispatch();

  return (
    <div className="error-popup-container">
      <div className="error-popup">
        <div className="error-popup-content">
          <div className="error-popup-header">{header || "Error"}</div>
          <div className="error-popup-desc">
            {errorText || "Something went wrong. Please try again."}
          </div>

          <Button
            btnName={"Cancel"}
            className={"blue-btn"}
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;
